<template>
  <div class="home">
    <OrderDisplayContainer />
  </div>
</template>

<script>
import OrderDisplayContainer from '@/modules/order';
export default {
  name: 'home',
  components: {
    OrderDisplayContainer
  }
}
</script>
